import ApiService from "@/common/api/api.service";
//import helpers from "@/common/utils/helpers";

const TermosService = {
  
    getPolitica: function() {
        return ApiService.get(`PoliticaPrivacidade`);
    },

    salvarPolitica: function(form){
        return ApiService.put(`PoliticaPrivacidade`, form);
    },


    getTermos: function() {
        return ApiService.get(`TermosServico`);
    },

    salvarTermo: function(form){
        return ApiService.put(`TermosServico`, form);
    }


};

export default TermosService;
